<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Garcia">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Garcia"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. José Luis García Hernández</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> luis_garher@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 3
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>Desarrollo Agrícola Sustentable</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            ING. AGRONOMO FITOTECNISTA (1993)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIDAD LAGUNA
                            <br>
                            UNIVIVERSIDAD AUTONOMA AGRARIA ANTONIO NARRO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>CIENCIAS EN PRODUCCION AGRONOMICA (1998)</li>
                            <p>
                                UNIDAD LAGUNA
                                <br>
                                UNIVERSIDAD AUTONOMA AGRARIA ANTONIO NARRO
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>CIENCIAS EN EL USO, MANEJO Y PRESERVACION DE LOS REC. NAT. (2001)</li>
                            <p>
                                CENTRO DE INVESTIGACIONES BIOLOGICAS DEL NOROESTE
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>Agricultura Sustentable de Zonas Áridas.</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/garcia.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'Artículo: Avila-Rodriguez V1, CA Vacio-Fraga1, U Nava-Camberos2, C Marquez-Hernandez1, C García de la Pena1, V Olalde-Portugal3, JL Garcia-Hernandez2. 2016.  Identification, population dynamics and parasitism of aphids in pecan in the Comarca Lagunera, Mexico. Revista International Journal of Experimental Botany 85:249-255 (Revista Indexada JCR)',
                    publicacion: 2016,
                },
                {
                    numero: 2,
                    titulo: 'Artículo: González B ML1, M Fortis H1, P Preciado R1, MA Segura C1, E Salazar Sosa1, JL García H2, JR Esparza R3. Phytochemical quality of tomato Saladette produced with organic substrates under greenhouse conditions. Revista International Journal of Experimental Botany  85: 71-78 (Revista Indexada  JCR).',
                    publicacion: 2016,
                },
                {
                    numero: 3,
                    titulo: 'Artículo: Valadez Sánchez YM1, E Olivares Saenz1, RE Vázquez Alvarado1, JR Esparza-Rivera3, P Preciado-Rangel4, RD Valdez-Cepeda5, JL Garcia-Hernandez2. 2016.  Quality and capsaicinoid concentration on genotypes of Serrano pepper (Capsicum annuum L.). produced under organic fertilization . Revista  International Journal of Experimental Botany 85: 21-26 (Revista Indexada JCR)',
                    publicacion: 2016,
                },
                {
                    numero: 4,
                    titulo: 'Artículo: Rosa I. Ramírez-Chávez, José D. López –Martínez, Enrique Troyo-Diéguez, Miguel A. Gallegos-Robles, Cirilo Vázquez-Vázquez, José A. Ramírez Ibarra y José L. García-Hernández. 2016.  Determinación preliminar de normas e interacciones nutrimentales en chile ancho (Capsicum annuum L.) en la Comarca Lagunera. Revista Electrónica Nova Scientia No.17 Vol. 8 (2), 2016. pp 198-218 (Revista Indexada CONACYT)',
                    publicacion: 2016,
                },
                {
                    numero: 5,
                    titulo: 'Artículo: José D. López-Martínez1, David A. Vázquez-Díaz2, Juan R. Esparza-Rivera3, José L. García-Hernández1, Miguel A. Castruita-Segura2 y Pablo Preciado-Rangel2*. 2016.  YIELD AND NUTRACEUTICAL QUALITY OF TOMATO FRUIT PRODUCED WITH NUTRIENT SOLUTIONS PREPARED USING ORGANIC MATERIALS. Revista Fitotecnia Mexicana Vol. 39 (4): 409 – 414. (Revista Indexada JCR) (Autor de correspondencia)',
                    publicacion: 2016
                },
                {
                    numero: 6,
                    titulo: 'Artículo:  José Apolinar Ramírez-Ibarra1, Uriel Figueroa-Viramontes2*, Gregorio Núñez-Hernández2, David Guadalupe Reta-Sánchez2, José Luis García-Hernández3. 2016.  Evaluación de métodos de labranza y aplicación de estiércol en la producción de maíz forrajero. Revista Chapingo Zonas Áridas 15(2), 67-76  (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2016
                },
                {
                    numero: 7,
                    titulo: 'Artículo: Ronald Lenin Jirón-Rojas, Urbano Nava-Camberos, Florencio Jiménez-Díaz, Omar Guadalupe Alvarado-Gómez, Verónica Ávila-Rodríguez y José Luis García-Hernández. 2016.  Densidades de Bactericera cockerelli (Sulc) e Incidencia del “Permanente del Tomate” en Diferentes Condiciones de Producción del Tomate. Revista Southwestern Entomologist 41(4):1085-1094 (Revista Indexada JCR)',
                    publicacion: 2016
                },
                {
                    numero: 8,
                    titulo: 'Artículo:  Ygor Ortega Mikolaev & Edgar Sánchez Bernal & José Bojorges Baños & Manuel Ortega Escobar & José García Hernández. 2016.  Saline Year-Gradients in the Lagoon BLa Salina,^ Tonameca, Oaxaca, Mexico: Effects on Growth of Mangrove Biotope. Revista Water Air and Soil Pollution  (2016) 227:426 (Revista Indexada JCR)',
                    publicacion: 2016
                },
                {
                    numero: 9,
                    titulo: 'Artículo: Lilia Salas-Pérez, José Luis García-Hernández, Cándido Márquez-Hernández+, Manuel Fortis-Hernández, Josué Raymundo Estrada-Arellano, Juan Ramón Esparza-Rivera, Pablo Preciado-Rangel*. 2017. Rendimiento y calidad nutracéutica de tomate en sustratos orgánicos. Revista Ecosistemas y Recursos Agropecuarios 4 (10): 169-175 (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2017
                },
                {
                    numero: 10,
                    titulo: 'Artículo:  José Apolinar Ramírez-Ibarra1, Enrique Troyo-Dieguez2, Pablo Preciado-Rangel3, Manuel Fortis-Hernández3, Miguel Ángel Gallegos-Robles4, Cirilo Vázquez-Vázquez4, Juan Luis Ríos-Plaza4, José Luis García-Hernández4*. 2017.  Diagnóstico de nutrimento compuesto e interacciones nutrimentales en chile Jalapeño (Capsicum annuum L.) en suelos semiáridos. Revista Ecosistemas y Recursos Agropecuarios 4(11):233-242,2017. (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2017
                },
                {
                    numero: 11,
                    titulo: 'Artículo: Anselmo González-Torres1, J Guadalupe Luna-Ortega2*, Miguel A Gallegos-Robles3, José L García-Hernandez3, Pablo Preciado-Rangel1, César Guerrero-Guerrero4, Mario García-Carrillo1. 2017. Aptitud combinatoria y heterosis en híbridos de líneas endogámicas de maíz. Revista Ecosistemas y Recursos Agropecuarios 4(11):223-232,2017. (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2017
                },
                {
                    numero: 12,
                    titulo: 'Artículo: J.L. Ríos-Plaza1, R.D. Valdez-Cepeda2, C. Vázquez-Vázquez3, I. Orona-Castillo3, M.A. Gallegos-Robles3, J.A. Ramírez-Ibarra4 y J.L.García Hernández3,*. 2017.  Normas nutrimentales preliminares para un cultivar criollo de Capsicum annuum con base en la técnica de diagnóstico de nutrimento compuesto. Revista Ríos-Plaza et al. ITEA (2017), Vol. 113 (3), 216-227. (Revista Indexada JCR) (Autor de correspondencia)',
                    publicacion: 2017
                },
                {
                    numero: 13,
                    titulo: 'Artículo: Saraí S. Mendoza-Retana 1, Miguel A. Gallegos-Robles 2*, Uriel González-Salas2, José L. García-Hernández2, Manuel Fortis-Hernández 3, Cirilo Vázquez-Vázquez 2 y Héctor I. Trejo-Escareño2. 2017. Polimorfismos del gen ob en bovinos de raza holstein en la Comarca Lagunera, México Ob Gene Polymorphisms in Holstein Cattle at Comarca Lagunera, México. Revista Electrónica Nova Scientia Nº 19, Vol. 9 (2), 2017 pp.: 372-392 (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2017
                },
                {
                    numero: 14,
                    titulo: 'Artículo: Javier Z. Castellanos, Pedro Cano-Ríos, Edgar M. García-Carrillo, V. Olalde-Portugal, Pablo Preciado-Rangel, Juan L. Ríos-Plaza & José L. García-Hernández. 2017. Hot Pepper (Capsicum annuum L.) Growth, Fruit Yield, and Quality Using Organic Sources of Nutrients. Revista Compost Science & Utilization ISSN: 1065-657X (Print) 2326-2397. (Revista Indexada JCR)',
                    publicacion: 2017
                },
                {
                    numero: 15,
                    titulo: 'Artículo: Carballo Méndez, Fernando de Jesús; Rodríguez Ortiz, Juan Carlos; García Hernández, José Luis; Alcalá Jáuregui, Jorge Alonso; Preciado Rangel, Pablo; Rodríguez Fuentes, Humberto; Villarreal Guerrero, Federico. 2017. Efecto de gallinaza y biosólido en mezcla con turba europea para producción de plántulas de cucurbitáceas. Revista de la Facultad de Ciencias Agrarias, vol. 49, núm. 2, 2017, pp. 193-202. (Revista Indexada JCR)',
                    publicacion: null
                },
                {
                    numero: 16,
                    titulo: 'Artículo: Arturo Cruz Falcón¹‡, Enrique Troyo Diéguez¹, Janette M. Murillo Jiménez², José Luis García Hernández³ y Bernardo Murillo Amador¹. 2018.  Familias de agua subterránea y distribución de sólidos totales disueltos en el acuífero de La Paz Baja California Sur, México Revista Terra Latinoamericana 36: 39-48. (Revista Indexada CONACYT)',
                    publicacion: 2018
                },
                {
                    numero: 17,
                    titulo: 'Artículo:  Lilia Salas-Pérez 1, Tiziana Fornari-Reale 2, Pablo Preciado-Rangel 3, José L. García-Hernández 4, Esteban Sánchez-Chávez 5 and Enrique Troyo-Diéguez 6,*. 2018. Cultivar Variety and Added Potassium Influence the Nutraceutical and Antioxidant Content in Hydroponically Grown Basil (Ocimum basilicum L.). Revista Agronomy 2018, 8, 13. (Revista Indexada CANACYT)',
                    publicacion: 2018
                },
                {
                    numero: 18,
                    titulo: 'Artículo:  Fernando de Jesús Carballo-Méndez, Juan Carlos Rodríguez-Ortiz, Jorge Alonso Alcalá-Jáuregui, Humberto Rodríguez-Fuentes, Pablo Preciado-Rangel and José Luis García-Hernández. 2018. COMPARISON OF TWO ORGANIC DETERMINATE TOMATO (Solanum lycopersicon L) PRODUCTION SYSTEMS IN A CONTROLLED ENVIRONMENT. Revista Interciencia VOL. 43 Nº 1, 62-65. (Revista Indexada JCR)',
                    publicacion: 2018
                },
                {
                    numero: 19,
                    titulo: 'Artículo: Ma. del Rosario Abraham-Juárez1, Isidro Espitia-Vázquez1, Rafael Guzmán-Mendoza1, Víctor Olalde-Portugal2, Graciela M. de la L. Ruiz-Aguilar1, José L. García-Hernández3, Lisset Herrera-Isidrón4, Héctor G. Núñez-Palenius1*. 2018. DESARROLLO, RENDIMIENTO Y CALIDAD DEL FRUTO DE MELÓN (Cucumis melo L.) DE PLANTAS INOCULADAS CON CEPAS MEXICANAS DE Bacillus subtilis (EHRENBERG). Revista  Agrociencia 52: 91-102. 2018. (Revista Indexada JCR) (Autor de correspondencia)',
                    publicacion: 2018
                },
                {
                    numero: 20,
                    titulo: 'Artículo:  José Luis García Hernández1, María Cristina Ruíz Alvarado3, Pablo Preciado Rangel4, Alejandra Nieto-Garibay4, Bernardo Murillo-Amador4, Francisco Higinio Ruiz-Espinoza5, Ramón Dolores Valdez Domínguez6 and Edgar Omar Rueda Puente6*. 2018.  PARÁMETROS DE CRECIMIENTO Y RENDIMIENTO DE Capsicum annuum VAR aviculare ASOCIADA A LAS BACTERIAS BENÉFICAS Bacillus amyloliquefaciens Y Azospirillum halopraeferens EN CONDICIONES DE CAMPO.  Revista Biotecnia  Volumen XX, Número 2 : 59-64 (2018). (Revista Indexada CONACYT) (Autor de correspondencia)',
                    publicacion: 2018
                },
                {
                    numero: 21,
                    titulo: 'Artículo: Rocío Jiménez-Delgadillo, Silvia Edith Valdés-Rodríguez, Víctor Olalde-Portugal*, Rosario Abraham-Juárez, José Luis García-Hernández. 2018. Efecto del pH y temperatura sobre el crecimiento y actividad antagónica de Bacillus subtilis sobre Rhizoctonia solani. Revista  Mexicana de Fitopatología 36(2) 256-275. (Revista Indexada CONACYT) (Autor por correspondencia)',
                    publicacion: 2018
                },
                {
                    numero: 22,
                    titulo: 'Artículo: Manuel Fortis-Hernández1; Pablo Preciado-Rangel1; Miguel A Segura-Castruita1; Leonel Mendoza-Tacuba1; Miguel A Gallegos-Robles3; José L García Hernández3; Cirilo Vásquez-Vásquez3*. 2018. Changes in nutraceutical quality of tomato under different organic substrates. Revista Horticultura Brasileira 36: 189-194. (Revista Indexada JCR) (Autor de correspondencia)',
                    publicacion: 2018
                },
                {
                    numero: 23,
                    titulo: 'Artículo: María A. Ávalos de la Cruz1, Uriel Figueroa Viramontes2, José L. García Hernández2, Cirilo Vázquez Vázquez2, Miguel A. Gallegos Robles2 e Ignacio Orona Castillo3. 2018. Bioinoculantes y Abonos Orgánicos en la Producción de Maíz Forrajero Bioinoculants and Organic Fertilizers in the Production of Silage Corn. Revisa Nova Scientia N°20, Vol. 10 (1):170-189. (Revista Indexada CONACYT).',
                    publicacion: 2018
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'Investigador responsable del Proyecto: “Procesos bioquímicos relacionados con el uso de macronutrimentos en la biosíntesis de compuestos que inciden en la concentración de capsaicionoides en genotipos élite de chile picoso del Norte de México”. Proyecto aprobado en la convocatoria de Investigación Científica Básica SEP-CONACYT 2015.',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'Investigador responsable del Proyecto: Selección de genotipos de chile serrano y jalapeño sobresalientes en producción y calidad en regiones semiáridas de Coahuila y Durango. Proyecto financiado por el Programa de Mejoramiento del Profesorado. Del 30 de agosto de 2011 al 29 de agosto de 2012.',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'Investigador responsable del Proyecto: “Caracterización morfológica, bioquimica y genética de poblaciones silvestres y criollas de chile adaptadas a los ambientes de las zonas aridas y semiaridas del norte de México”. Proyecto aprobado en la convocatoria de Investigación Científica Básica SEP-CONACYT 2009.',
                    tipo: 'EXTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
